// extracted by mini-css-extract-plugin
module.exports = {"column":"Table_column__Wv4I9","disabled":"Table_disabled__2yXTW","table":"Table_table__2Lclm"};